import React from "react";
import { UpdateDeploymentProps } from "../../components/DeploymentDetails";
import UpdateDeploymentFormLegacy from "./UpdateDeploymentFormLegacy";
import UpdateDeploymentFormRegional from "./UpdateDeploymentFormRegional";

export interface UpdateDeploymentFormProps {
  onCancel: () => void;
  onSuccess?: () => void;
  basePath: string;
  version: string;
  availableRegions: { key: string; value: string }[];
  updateDeploymentInitialValue?: UpdateDeploymentProps;
}

const supportRegionalDeployments =
  process.env.REACT_APP_SUPPORT_REGIONAL_DEPLOYMENTS === "true";

const UpdateDeploymentForm: React.FC<UpdateDeploymentFormProps> = (props) => {
  if (!supportRegionalDeployments) {
    return <UpdateDeploymentFormLegacy {...props} />;
  }

  return <UpdateDeploymentFormRegional {...props} />;
};

export default UpdateDeploymentForm;
